import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { Router } from '@angular/router';
import {
  CustomerSearchInputComponent,
  DateSelectionService,
  PageComponent,
  PageHeaderComponent } from '@softapps/core';
import { ContentWidgetComponent } from '@softapps/migel/core';
import {
  BackNavigable,
  BackNavigationService,
  DashboardComponent,
  SOFTLINE_FEATURE_TITLE,
  TitleStore } from '@softline/application';
import { Store } from '@softline/core';
import { MetaForm, MetaFormComponent, toModel, toSignalForm } from '@softline/dynamic';
import { DashboardDateSelectionService } from '../../services/dashboard-date-selection.service';

export interface CustomForm {
  firstName: string;
  lastName: string;
  readonly: string;
  disabled: string;
  hidden: string;
  no: number;
}

@Component({
  selector: 'soft-dashboard-page',
  imports: [
    DashboardComponent,
    ContentWidgetComponent,
    PageComponent,
    PageHeaderComponent,
    MetaFormComponent,
    FormField,
    CustomerSearchInputComponent],
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.css'],
  providers: [{ provide: DateSelectionService, useClass: DashboardDateSelectionService }],
  changeDetection: ChangeDetectionStrategy.OnPush })
export class DashboardPage implements OnInit, OnDestroy, BackNavigable {
  dateSelectionService = inject(DateSelectionService);

  meta: MetaForm<CustomForm> = {
    firstName: {
      label: 'First Name',
      type: 'string' },
    lastName: {
      label: 'Last Name',
      type: 'string',
      required: true },
    readonly: {
      label: 'Readonly Field',
      type: 'string',
      readonly: true,
      default: 'Test Readonly' },
    disabled: {
      label: 'Disabled Field',
      type: 'string',
      default: 'Test Disabled',
      disabled: true },
    hidden: {
      label: 'Hidden Field',
      type: 'string',
      default: 'Hidden Disabled',
      hidden: true },
    no: {
      label: 'Number Field',
      type: 'number',
      required: true } };

  customModel = toModel(signal(this.meta));
  customForm = toSignalForm(this.meta, this.customModel);

  constructor(
    private store: Store,
    private router: Router,
    private backNavigationService: BackNavigationService
  ) {}

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#DASHBOARD.TITLE'
    );
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }
}
